import React, { useCallback, useEffect, useState, memo } from 'react'
import { Col, Form, Row } from 'react-bootstrap'
import { emptyDate } from '../../../utils/emptyDate'
import CustomDatePicker from '../../Forms/CustomDatePicker'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { emptyGuid, isEmptyGuid } from '../../../utils/emptyGuid'
import { StyledValidationMessage } from './formHelper'
import ArraySelect from '../../Select/ArraySelect'
import MandatoryField from '../../MandatoryField/MandatoryField'
import apiClient from '../../../utils/api/apiClient'
import { APIEndpoints } from '../../../utils/api/apiConfig'
import { getIsoDate } from '../../../utils/getIsoDate'

const StyledWrapper = styled.div`
  .form-label {
    white-space: nowrap;
  }
`

const HeaderData = memo(({
    headerData,
    setHeaderDataByKey,
    formErrors,
    resetErrorByFormKey,
    actionMode
}) => {
  const [expectedTimeOfArrival, setExpectedTimeOfArrival] = useState('')
  const [availableStorehouses, setAvailableStorehouses] = useState([])
  const [availableSuppliers, setAvailableSuppliers] = useState([])

  const isStoring = () =>{
    return actionMode ==="store";
  }
  const isRellocation = () =>{
    return headerData.receiptType === "relocation";
  }
  const getHeaderDataByKeyIsEditable = (key) => {
    let defValue = !isStoring();
    switch(key)
    {
      case "id":
        return false;
      case "displayName":
          return isEmptyGuid(headerData.id);
      case "targetStorehouse.id":
          return isEmptyGuid(headerData.id);
      case "supplier.id":
          return !isRellocation() && defValue;
      default:
        return defValue;
    }
  }
  useEffect(() => {
    //load settings data
    (async () => {
      const storehouses = await apiClient.getJson(APIEndpoints.storehouses())
      setAvailableStorehouses(storehouses.filter(item => item.isVirtual))
      const suppliers = await apiClient.getJson(APIEndpoints.suppliers)
      setAvailableSuppliers(suppliers)
    })()
  }, [])
  const setDateWithString = useCallback((setDate, dateISOString) => {
    if (dateISOString && dateISOString !== emptyDate) {
      setDate(new Date(dateISOString))
    } else {
      setDate('')
    }
  }, [])
  useEffect(() => {
    setDateWithString(setExpectedTimeOfArrival, headerData.expectedTimeOfArrival)
  }, [headerData.expectedTimeOfArrival, setDateWithString])

  const handleChangeDate = name => date => {
    setHeaderDataByKey(name, (date && getIsoDate(date)) || '')
    resetErrorByFormKey(name)
  }
  const handleCange = (e) => {
    const { name, value } = e.target
    setHeaderDataByKey(name, value)
    resetErrorByFormKey(name)
  }
  const { t } = useTranslation()

  return (
    <>
      <h2 className="h1">{t('goodsReceiptOverlayProgress:headerData')}</h2>
      <StyledWrapper className="spacing-down">
        <Row>
          <Col lg="3" sm="6" xs="12">
            <Form.Group className="mb-3">
              <Form.Label>{t('goodsReceiptsTable:receiptNo')} *</Form.Label>
              <Form.Control
              id="displayName"
              name="displayName"
              placeholder={t('goodsReceiptsTable:receiptNo')}
              value={headerData.displayName}
              disabled={!getHeaderDataByKeyIsEditable('displayName')}
              onChange={handleCange}
              isInvalid={!!formErrors['headerdisplayName']}
            />
             <Form.Control.Feedback type="invalid">
                {formErrors['headerdisplayName']}
              </Form.Control.Feedback>
            </Form.Group >
          </Col>
          <Col sm="6" lg="3">
          <Form.Group className="mb-3">
              <Form.Label>{t('goodsReceiptsTable:warehouse')} *</Form.Label>
              <ArraySelect
                returnEvent
                options={availableStorehouses}
                defaultOption={{ name: t('pleaseSelect'), value: emptyGuid }}
                //defaultOptionIsSelectable
                name="targetStorehouse.id"
                disabled={!getHeaderDataByKeyIsEditable('targetStorehouse.id')}
                value={headerData.targetStorehouse.id}
                onChange={handleCange}
                isInvalid={!!formErrors['headertargetStorehouseid']}
              />
            <Form.Control.Feedback type="invalid">
                {formErrors['headertargetStorehouseid']}
              </Form.Control.Feedback>
            </Form.Group>
            </Col>
            <Col sm="6" lg="3">
            <Form.Group className="mb-3">
              <Form.Label>{t('goodsReceiptsTable:expectedTimeOfArrival')}</Form.Label>
              <CustomDatePicker
                dateFormat="dd.MM.yyyy"
                placeholderText={t('date')}
                onChange={handleChangeDate('expectedTimeOfArrival')}
                showYearDropdown
                selected={expectedTimeOfArrival}
                disabled={!getHeaderDataByKeyIsEditable('expectedTimeOfArrival')}
                isInvalid={!!formErrors['headerexpectedTimeOfArrival']}
              />
              {!!formErrors['headerexpectedTimeOfArrival'] &&
                <StyledValidationMessage>{formErrors['headerexpectedTimeOfArrival']}</StyledValidationMessage>
              }
            </Form.Group>
            </Col>
            <Col sm="6" lg="3">
            {!isRellocation() &&
              <Form.Group className="mb-3">
                <Form.Label>{t('goodsReceiptsTable:supplier')}</Form.Label>
                <ArraySelect
                  returnEvent
                  options={availableSuppliers}
                  defaultOption={{ name: t('pleaseSelect'), value: emptyGuid }}
                  defaultOptionIsSelectable
                  name="supplier.id"
                  disabled={!getHeaderDataByKeyIsEditable('supplier.id')}
                  value={headerData.supplier.id}
                  onChange={handleCange}
                  isInvalid={!!formErrors['headersupplierid']}
                />
                <Form.Control.Feedback type="invalid">
                  {formErrors['headersupplierid']}
                </Form.Control.Feedback>
              </Form.Group>
            }
          </Col>
        </Row>
        <Form.Group className="mb-3">
              <Form.Label>{t('goodsReceiptPage:comment')}</Form.Label>
              <Form.Control
                as="textarea"
                placeholder={t('goodsReceiptPage:comment')}
                value={headerData.comment}
                onChange={handleCange}
                name="comment"
                disabled={!getHeaderDataByKeyIsEditable('comment')}
                isInvalid={!!formErrors['headercomment']}
            />
             <Form.Control.Feedback type="invalid">
                {formErrors['headercomment']}
              </Form.Control.Feedback>
            </Form.Group >
        <MandatoryField />
      </StyledWrapper>
    </>
  )
})

export default HeaderData
